// extracted by mini-css-extract-plugin
module.exports = {"select":"SendToBoard_select__2Y5gh","loadingContainer":"SendToBoard_loadingContainer__4Esvv"};